export default __webpack_public_path__ + "static/media/msf_m2.23835773.png";